"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKCard = void 0;
var React = __importStar(require("react"));
var reactstrap_1 = require("reactstrap");
var common_1 = require("../../common");
var models_1 = require("../../models");
require("./GKCard.css");
/**
 * Provide a flexible and extensible content container with multiple variants and options
 */
var GKCard = function (props) {
    var _a;
    var _b = (0, common_1.mapDefaultProps)(props, { _gkComponentName: "gk-card" }), active = _b.active, children = _b.children, className = _b.className, onClick = _b.onClick, payload = _b.payload, otherProps = __rest(_b, ["active", "children", "className", "onClick", "payload"]);
    // Add classes for styling clickable/active cards.
    var classes = (className === null || className === void 0 ? void 0 : className.split(" ")) || [];
    if (onClick) {
        classes.push("clickable");
    }
    if (active) {
        classes.push("active");
    }
    // Handle click and keyboard events.
    var handleClick = function () { return onClick === null || onClick === void 0 ? void 0 : onClick(payload); };
    var keyboardController = new models_1.KeyboardNavigationController((_a = {},
        _a[models_1.NavigationKey.Enter] = handleClick,
        _a));
    return (React.createElement(reactstrap_1.Card, __assign({}, otherProps, { onClick: handleClick, onKeyDown: keyboardController.keyEventHandler, className: classes.join(" "), tabIndex: onClick ? 0 : undefined }), children));
};
exports.GKCard = GKCard;
exports.default = exports.GKCard;
